<div class="p-3">
    <div class="page-title d-flex justify-content-between align-items-center px-1">
        <h3>Tour</h3>
        <div class="d-flex gap-2">
            <ng-container *ngIf="!isTenant">
                <p-button type="button" icon="pi pi-sync" class="primary-btn p-button-secondary"
                    (click)="resetFilters()"></p-button>
                <p-button type="button" label="Add Tour" icon="pi pi-plus" class="primary-btn"
                    (click)="showDialogForCreate('right')"></p-button>
            </ng-container>
            <p-button *ngIf="isTenant" type="button" label="Add Blackout" icon="pi pi-ban" class="primary-btn"
                (click)="openBlackoutCalendar()"></p-button>
        </div>
    </div>

    <!-- Tenant filters: search, status, plan -->
    <div *ngIf="isTenant" class="filters">
        <div class="row">
            <div class="col-lg-3 col-sm-6 col-12">
                <label class="dropdown-label">Search</label>
                <input type="text" placeholder="Search by customer or plan..." class="form-control"
                    [(ngModel)]="filters.search"
                    (input)="onFilterChange(); sanitizeInput($event)"
                    (keydown)="blockSpecialChars($event)"
                    (paste)="blockSpecialCharsOnPaste($event)"
                    (drop)="blockSpecialCharsOnDrop($event)">
            </div>
            <div class="col-lg-3 col-sm-6 col-12">
                <label class="dropdown-label">Status</label>
                <p-dropdown [options]="statuses" [(ngModel)]="filters.status"
                    placeholder="All Statuses" (onChange)="onFilterChange()"
                    [showClear]="true"></p-dropdown>
            </div>
            <div class="col-lg-3 col-sm-6 col-12">
                <div class="d-flex gap-2">
                    <div class="w-100">
                        <label class="dropdown-label">Plan Name</label>
                        <p-dropdown filter="true" [options]="planNames" [(ngModel)]="filters.plan_name"
                            placeholder="All Plans" (onChange)="onFilterChange()"
                            [showClear]="true"></p-dropdown>
                    </div>
                    <div>
                        <label class="dropdown-label">&nbsp;</label>
                        <p-button type="button" icon="pi pi-sync" class="primary-btn p-button-secondary"
                        (click)="resetFilters()"></p-button>
                    </div>
                </div>
            </div>
            <div class="p-1">
            </div>
        </div>
    </div>

    <div *ngIf="!isTenant" class="filters">
        <div class="filters-container w-100 m-0">
            <div class="p-1 w-100">
                <label for="search" class="dropdown-label">Search</label>
                <input type="text" placeholder="Search..." class="form-control" [(ngModel)]="filters.search" (input)="onFilterChange(); sanitizeInput($event)" 
                 (keydown)="blockSpecialChars($event)" (paste)="blockSpecialCharsOnPaste($event)" (drop)="blockSpecialCharsOnDrop($event)">
            </div>
            <div class="p-1 w-100">
                <label for="planName" class="dropdown-label">Plan Name</label>
                <p-dropdown filter="true" [options]="planNames" [(ngModel)]="filters.plan_name"
                    placeholder="Select Plan" (onChange)="onFilterChange()" [showClear]="true"></p-dropdown>
            </div>
            <div class="p-1 w-100">
                <label for="user_id">Resident</label>
                <p-dropdown [options]="agents" [(ngModel)]="filters.user_id" placeholder="Select Resident"
                    (onChange)="onFilterChange()" [showClear]="true" filter="true"></p-dropdown>
            </div>
            <div class="p-1 w-100">
                <label for="status" class="dropdown-label">Status</label>
                <p-dropdown filter="true" [options]="statuses" [(ngModel)]="filters.status" placeholder="Select Status"
                    (onChange)="onFilterChange()" [showClear]="true"></p-dropdown>
            </div>
            <div class="p-1 w-100">
                <div class="d-flex flex-column gap-1">
                    <label for="appointmentDate" class="dropdown-label">Appointment Date</label>
                    <p-calendar [(ngModel)]="filters.appointmentDate" selectionMode="range" dateFormat="mm/dd/yy"
                        appendTo="body" placeholder="Select Date Range" [showIcon]="true" (onSelect)="onFilterChange()"
                        [numberOfMonths]="2" [showClear]="true" (ngModelChange)="onDateChange($event)">
                    </p-calendar>
                </div>
            </div>
            <div class="p-1 w-100">
                <label for="lead_source" class="dropdown-label">Lead Source</label>
                <p-dropdown [options]="leadSources" [(ngModel)]="filters.lead_source" placeholder="Select Lead Source"
                    (onChange)="onFilterChange()" [showClear]="true"></p-dropdown>
            </div>
        </div>
    </div>
    <!-- <div class="page-title d-flex justify-content-between align-items-center px-1">
        <h3>Blackout Dates</h3>
        <div class="d-flex gap-2">
            <p-calendar 
                [(ngModel)]="selectedBlackoutDate"
                [inline]="true"
                [showIcon]="false"
                [touchUI]="false"
                [minDate]="minDate"
                [style]="{ width: '100%' }"
                class="text-center"
                [readonlyInput]="true"
                appendTo="body"
                (onSelect)="onBlackoutDateSelect($event)">
            </p-calendar>
        </div>
    </div> -->
    <!-- Landlord: inline calendar (unchanged) -->
    <div *ngIf="!isTenant" class="calendar-holder p-4 m-1">
        <h3>Blackout Dates</h3>
        <full-calendar #calendar [options]="calendarOptions">
            <ng-template #eventContent let-arg>
                <ng-container *ngIf="!arg.event.extendedProps?.isBackground">
                    <div class="blackout-container" [title]="getBlackoutTooltip(arg.event.extendedProps)">
                        <span class="blackout-label">{{ arg.event.title }}</span>
                        <span *ngIf="!arg.event.extendedProps?.blackout?.isFullDay"
                            class="blackout-edit"
                            (click)="onBlackoutDateSelect(arg.event.extendedProps.blackout.date); $event.stopPropagation();">✏️</span>
                        <span class="blackout-close"
                            (click)="showDeleteBlackoutDialog(arg.event.extendedProps.blackout._id); $event.stopPropagation();">&times;</span>
                    </div>
                </ng-container>
            </ng-template>
        </full-calendar>
    </div>

    <!-- Tenant: calendar inside a dialog, initialized on open -->
    <p-dialog *ngIf="isTenant" header="Blackout Dates" [(visible)]="showBlackoutSection"
        [modal]="true" [style]="{width: '95vw', maxWidth: '1200px', height: '85vh'}"
        [contentStyle]="{'height': 'calc(85vh - 60px)', 'overflow': 'auto'}"
        [draggable]="false" (onShow)="onTenantCalendarShow()">
        <div class="calendar-holder p-3">
            <full-calendar #tenantCalendar [options]="calendarOptions" style="height: 100%;">
                <ng-template #eventContent let-arg>
                <ng-container *ngIf="!arg.event.extendedProps.isBackground">
                    <div class="blackout-label-event"  [title]="getBlackoutTooltip(arg.event.extendedProps)">
                        <span class="bl-text">{{ arg.event.title }}</span>
                        <span *ngIf="arg.event.extendedProps.blackout?.userId"
                            class="bl-close"
                            (click)="showDeleteBlackoutDialog(arg.event.extendedProps.blackout._id); $event.stopPropagation();">&times;</span>
                    </div>
                </ng-container>
                </ng-template>
            </full-calendar>
        </div>
    </p-dialog>
    <div class="follow-up-listing p-3 m-1 mt-3">
        <p-table #dt2 [value]="followUps" responsiveLayout="scroll" [lazy]="true" [paginator]="true" [rows]="10"
            [totalRecords]="totalRecords" [responsiveLayout]="'scroll'" [sortField]="sorting.field"
            [sortOrder]="sorting.order" (onLazyLoad)="getAllFollowups($event)" [rowsPerPageOptions]="[10,20,50]"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" responsiveLayout="scroll"
            (onRowSelect)="onClickInfoButton($event)" [(selection)]="selectedTour">

            <ng-template pTemplate="header">
                <tr>
                    <th *ngIf="!isTenant" pSortableColumn="customer_name">Tour ID <p-sortIcon field="customer_name"></p-sortIcon></th>
                    <th *ngIf="!isTenant" pSortableColumn="tour_no">Tour No <p-sortIcon field="tour_no"></p-sortIcon></th>
                    <th pSortableColumn="customer_name">Lead <p-sortIcon field="customer_name"></p-sortIcon>
                    </th>
                    <th *ngIf="!isTenant" pSortableColumn="customer_email">Customer Email <p-sortIcon field="customer_email"></p-sortIcon>
                    </th>
                    <th *ngIf="!isTenant" pSortableColumn="phone_number">Customer Phone <p-sortIcon field="phone_number"></p-sortIcon>
                    </th>
                    <th pSortableColumn="plan_name">Plan Name <p-sortIcon field="plan_name"></p-sortIcon></th>
                    <th *ngIf="!isTenant">Lead Source</th>
                    <th *ngIf="!isTenant" pSortableColumn="user_name">Resident <p-sortIcon field="user_name"></p-sortIcon></th>
                    <th pSortableColumn="status">Tour Status <p-sortIcon field="status"></p-sortIcon></th>
                    <th pSortableColumn="date">Date & Time<p-sortIcon field="date"></p-sortIcon></th>
                    <!-- <th pSortableColumn="time">Time <p-sortIcon field="time"></p-sortIcon></th> -->
                    <th *ngIf="!isTenant">Actions</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-followUp>
                <tr>
                    <td *ngIf="!isTenant">{{ followUp.tour_id }}</td>
                    <td *ngIf="!isTenant">{{ followUp.tour_no }}</td>
                    <td>
                        {{ followUp.customer_name }}
                        <ng-container *ngIf="followUp.tourMeta?.tags?.length > 0">
                            <div class="d-flex gap-1 mt-1 align-items-center status">
                                <span *ngFor="let tag of followUp.tourMeta.tags | slice:0:2" 
                                    class="badge rounded-pill px-2 py-1"
                                    [style]="{'background-color': $any(tag).color, 'color': '#fff', 'font-size': '11px'}">
                                    {{ $any(tag).name }}
                                </span>

                                <!-- Remaining tags tooltip -->
                                <span *ngIf="followUp.tourMeta.tags.length > 2"
                                        class="text-muted fw-bold" 
                                        [pTooltip]="(followUp.tourMeta.tags.length - 2) + ' more '+ ((followUp.tourMeta.tags.length - 2) === 1 ? 'tag' : 'tags')"
                                        tooltipPosition="top"
                                        style="cursor: help; font-size: 14px; line-height: 1;">
                                    {{ followUp.tourMeta.tags.length - 2 }}+
                                </span>
                            </div>
                        </ng-container>
                    </td>
                    <td *ngIf="!isTenant">{{ followUp.customer_email }}</td>
                    <td *ngIf="!isTenant">{{ followUp.phone_number | phoneFormat:'US' }}</td>
                    <td>{{ followUp.plan_name }}</td>
                    <td *ngIf="!isTenant">{{ followUp.external_lead_source || 'Petrie' }}</td>
                    <td *ngIf="!isTenant">{{ followUp.user_name || 'To Be Assigned' }}</td>
                    <td [ngClass]="'status' + tourStatus(followUp).class">
                        <span>{{ tourStatus(followUp).text }}</span>
                        <span *ngIf="followUp.tourStatus === 'cancelled' && followUp.rescheduleRequest"
                              class="badge bg-warning text-dark ms-1"
                              style="font-size: 0.7em; vertical-align: middle;"
                              pTooltip="Lead selected: {{followUp.rescheduleRequest?.date}} at {{followUp.rescheduleRequest?.time}}"
                              tooltipPosition="top">
                            Reschedule Pending
                        </span>
                    </td>
                    <td>
                        {{ followUp.date + ' ' + followUp.time | timezoneDate:userInfo?.property?.timezone:'time' }} 
                        {{ followUp.date + ' ' + followUp.time | timezoneDate:userInfo?.property?.timezone:'date' }}
                    </td>
                    <td *ngIf="!isTenant">
                        <div class="d-flex align-items-center gap-2">
                            <p-button pButton icon="pi pi-info" class="icon-primary-btn"
                                (click)="onClickInfoButton(followUp)" [pTooltip]="getLatestNote(followUp)" tooltipPosition="top"></p-button>
                            <ng-container *ngIf="!isTenant">
                                <p-button pButton icon="pi pi-pencil" class="icon-primary-btn"
                                    (click)="showDialogForEdit('right', followUp)"></p-button>
                                <p-button *ngIf="followUp.status == 'Active' && followUp.tourStatus == 'in_progress'" type="button" icon="pi pi-times" class="icon-primary-btn"
                                    (click)="confirmCancelTour(followUp)"></p-button>
                                <p-button *ngIf="followUp.status == 'Active' && followUp.tourStatus == 'in_progress'"
                                type="button" icon="pi pi-calendar" class="icon-primary-btn"
                                    (click)="showDialogForReschedule('right', followUp)"></p-button>
                                <!-- C2: Confirm lead-selected reschedule slot -->
                                <p-button *ngIf="followUp.tourStatus === 'cancelled' && followUp.rescheduleRequest"
                                    type="button" icon="pi pi-check" class="icon-primary-btn"
                                    pTooltip="Confirm New Tour: {{followUp.rescheduleRequest?.date}} at {{followUp.rescheduleRequest?.time}}"
                                    tooltipPosition="top"
                                    (click)="confirmReschedule(followUp)"></p-button>
                                <!-- C3: Send more availability slots to lead -->
                                <p-button *ngIf="followUp.tourStatus === 'cancelled' && !followUp.rescheduleRequest"
                                    type="button" icon="pi pi-send" class="icon-primary-btn"
                                    pTooltip="Send More Times"
                                    tooltipPosition="top"
                                    (click)="sendMoreTimes(followUp)"></p-button>
                                <p-button type="button" icon="pi pi-trash" class="icon-primary-btn"
                                    (click)="confirmDeleteFollowup(followUp)"></p-button>
                            </ng-container>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <div *ngIf="!followUps || followUps.length === 0" class="alert alert-info" role="alert">
        No follow-ups available.
    </div>
</div>

<app-message-conversation 
*ngIf="isOpen" 
[isSystemConversation]="isSystemConversation"
[isLoading]="isLoading"
[contactInfo]="selectedTour" 
[userType]="userInfo.user_type"
[property]="userInfo.property.name"
[conversations]="selectedTour?.messages" 
(fetchConversation)="fetchSpecificConversationNew($event)"
(close)="isOpen=false">
</app-message-conversation>

<p-dialog *ngIf="visible" [header]="headerText+' Tour'" [modal]="true" [(visible)]="visible"
    [position]="position" [style]="{ width: '35%' }" draggable="false">
    <app-create-tours *ngIf="visible" [buttonLabel]="headerText" [planNames]="planNames"
        [tourData]="selectedTour" (closeDialog)="onDialogClose()"></app-create-tours>
</p-dialog>

<!-- Confirm Cancel Dialog -->
<p-dialog header="Confirm Cancel" [(visible)]="showCancelDialog" modal="true" [closable]="false" [responsive]="true"
    [style]="{width: '350px'}">
    <div class="confirmation-content">
        <p>Are you sure you want to cancel? All unsaved changes will be lost.</p>
    </div>
    <div class="d-flex justify-content-end gap-2 mt-3">
        <p-button label="No" (click)="declineCancel()"></p-button>
        <p-button label="Yes" class="p-button-danger" (click)="confirmCancelAdd()"></p-button>
    </div>
</p-dialog>

<!-- Confirm Delete Dialog -->
<p-dialog header="Confirm Delete" [(visible)]="showDeleteDialog" modal="true" [closable]="false" [responsive]="true"
    [style]="{width: '350px'}">
    <div class="confirmation-content">
        <p>Are you sure you want to delete this tour?</p>
    </div>
    <div class="d-flex justify-content-end gap-2 mt-3">
        <p-button label="No" (click)="cancelDelete()"></p-button>
        <p-button label="Yes" class="p-button-danger" (click)="deleteFollowup()"></p-button>
    </div>
</p-dialog>

<!-- Calendly Link Dialog -->
<p-dialog header="Calendly Link" [(visible)]="showLinkDialog" modal="true" [closable]="true" [style]="{width: '350px'}">
    <p>
        Click
        <a [href]="calendlyLink" target="_blank" rel="noopener noreferrer" class="text-primary">here</a>
        to Book Meeting on Calendly.
    </p>
</p-dialog>

<!-- Confirm Cancel Tour Dialog -->
<p-dialog header="Cancel Tour" [(visible)]="cancelTourDialog" modal="true" [closable]="false" [responsive]="true"
    [style]="{width: '350px'}">
    <div class="confirmation-content">
        <p>Are you sure you want to cancel this tour?</p>
    </div>
    <div class="d-flex justify-content-end gap-2 mt-3">
        <p-button label="No" (click)="cancelDelete()" [disabled]="isCancelling"></p-button>
        <p-button label="Yes" class="p-button-danger" (click)="cancelTour()" [loading]="isCancelling"></p-button>
    </div>
</p-dialog>

<p-dialog header="{{editingBlackoutId ? 'Edit Blackout' : 'Add Blackout'}}" [(visible)]="showBlackoutDialog" [modal]="true" [closable]="true">
    <div class="p-fluid">
        <div class="p-field">
            <label for="blackoutType">Blackout Type</label>
            <p-dropdown
                id="blackoutType"
                [options]="blackoutTypes"
                [(ngModel)]="isFullDayBlackout"
                placeholder="Select Type"
                optionLabel="label"
                optionValue="value"
            ></p-dropdown>
        </div>

        <div *ngIf="!isFullDayBlackout" class="mt-1">
            <label>Start Time</label>
            <!-- <p-calendar
            id="startTime"
            formControlName="blackoutStartTime"
            [showIcon]="true" 
            [iconDisplay]="'input'"
            timeOnly="true"
            hourFormat="12" 
            placeholder="Start"
            [stepMinute]="30"
            (onSelect)="onTimeChange($event)"
            readonlyInput="true"
            inputmode="none"
            ></p-calendar> -->
            <p-calendar
            id="startTime"
            [(ngModel)]="blackoutStartTime"
            [showIcon]="false" 
            timeOnly="true"
            hourFormat="12"
            [stepMinute]="30"
            readonlyInput="true"
            inputmode="none"
            placeholder="From"
            ></p-calendar>

            <label>End Time</label>
            <!-- <p-calendar
            id="endTime"
            formControlName="blackoutEndTime"
            [showIcon]="true" 
            [iconDisplay]="'input'"
            timeOnly="true"
            hourFormat="12" 
            placeholder="End"
            [stepMinute]="30"
            (onSelect)="onTimeChange($event)"
            readonlyInput="true"
            inputmode="none"
            ></p-calendar> -->
            <p-calendar
            id="startTime"
            [(ngModel)]="blackoutEndTime"
            [showIcon]="false" 
            timeOnly="true"
            hourFormat="12"
            [stepMinute]="30"
            readonlyInput="true"
            inputmode="none"
            placeholder="To"
            ></p-calendar>
        </div>

        <label>Reason</label>
        <input type="text" [(ngModel)]="blackoutReasonText" placeholder="Holiday / Maintenance" class="p-inputtext p-component">
    </div>

    <p-footer>
        <div class="d-flex justify-content-end gap-2 mt-3">
            <button pButton type="button" label="Cancel" class="p-button-secondary gap-2" (click)="showBlackoutDialog=false"></button>
            <button pButton type="button" label="Save" class="p-button-primary gap-2" (click)="saveBlackout()"></button>
        </div>
    </p-footer>
</p-dialog>

<!-- Confirm Delete Dialog -->
<p-dialog header="Confirm Delete" [(visible)]="showBalckoutDeleteDialog" modal="true" [closable]="false" [responsive]="true"
    [style]="{width: '350px'}">
    <div class="confirmation-content">
        <p>Are you sure you want to delete this blackout?</p>
    </div>
    <div class="d-flex justify-content-end gap-2 mt-3">
        <p-button label="No" (click)="cancelDeleteBlackout()"></p-button>
        <p-button label="Yes" class="p-button-danger" (click)="confirmDeleteBlackout()"></p-button>
    </div>
</p-dialog>

<p-toast></p-toast>